"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var Translation_1 = require("../Translation");
var AbstractRisk_1 = require("../risk/AbstractRisk");
var AbstractControl_1 = __importStar(require("./AbstractControl"));
var DesignReportColumn_1 = require("./DesignReportColumn");
var CONTROL_TYPES = [
    { key: 'id', required: true },
    { key: 'narrative', required: true },
    { title: '규정 및 자원' },
    { key: 'policy' },
    { key: 'ITDependencySystem' },
    { title: 'MRC' },
    { key: 'MRC_YN', radio: AbstractControl_1.YesNo },
    { key: 'MRC_Number' },
    { key: 'MRC_IPE_Name' },
    { title: 'IPE 통제' },
    { key: 'IPE_YN', radio: AbstractControl_1.YesNo },
    { key: 'IPE_Number' },
    { key: 'IPE_Name' },
    { title: '통제 조직' },
    { key: 'department', required: true, isDepartment: true },
    { key: 'incharge', isStaff: true },
    { key: 'owner', isStaff: true },
    { key: 'teamLeader' },
    { key: 'teamMember' },
    { title: '기타 통제 속성' },
    { key: 'keyControl', radio: AbstractControl_1.YesNo },
    {
        key: 'goal',
        prefix: 'goal',
        checks: ['Trust', 'Override', 'Operation', 'Law', 'Asset']
    },
    { key: 'accountCode' },
    { key: 'accountName' },
    { key: 'reportFootnotes' },
    {
        key: 'assertion',
        prefix: 'assertion',
        checks: ['EO', 'C', 'RO', 'PD', 'Occur', 'Assessment', 'Measurement']
    },
    { key: 'period', radio: AbstractControl_1.Period },
    { key: 'preventDetective', radio: AbstractControl_1.PreventDetective },
    { key: 'autoManual', radio: AbstractControl_1.AutoManual },
    { key: 'residualRiskLevel', radio: AbstractRisk_1.RiskLevel },
    { title: '통제 운영 속성' },
    { key: 'controlRiskLevel', radio: AbstractRisk_1.RiskLevel },
    { key: 'TOC_Procedure' },
    { key: 'TOC_Evidence' },
    { key: 'TOC_Population' },
    { key: 'TOC_PopulationCount' },
    { key: 'TOC_TestProperties' },
    { key: 'TOC_Exception' },
    {
        key: 'TOC_TestMethod',
        prefix: 'TOC_TestMethod',
        checks: ['InquiryInspection', 'Observation', 'Reperformance']
    }
];
var CONSIDERATIONS = [
    {
        title: '설계된 통제가 관련 “what could go wrong”을 다루고 대응하는 목적을 충족하는지',
        content: '관련 계정과목과 경영진주장의 중요한 왜곡표시위험에 충분히 대처하는지 평가한다.'
    },
    {
        title: '통제수행자가 해당 통제의 목적에 적합한 적격성과 권한을 지녔는지?',
        content: '통제수행자가 적절한 지식, 적격성과 권한을 보유하고 있는 것을 입증할 수 있는' +
            ' 증거가 무엇인지 평가한다.'
    },
    {
        title: '이상항목들을 적시에 식별하고 조사하고 해결하기에 통제의 수행 빈도가 왜 충분한지?',
        content: '통제가 이상항목을 적시에 식별, 조사 그리고 해결할 수 있는 충분한 빈도로' +
            ' 수행되고 있다는 증거가 무엇인지 평가한다.(실제 재무제표에 중요한' +
            ' 영향을 미치기 전에 왜곡표시를 예방 또는 적발 할 수 있는 빈도인지?)'
    }
];
function getDesignControlTypes() {
    return [
        [
            { value: (0, Translation_1.getKoName)('control', 'keyControl'), span: 3, style: DesignReportColumn_1.blueStyle },
            { key: 'content.control.keyControl', span: 3 },
            { value: (0, Translation_1.getKoName)('control', 'autoManual'), span: 3, style: DesignReportColumn_1.blueStyle },
            { key: 'content.control.autoManual', span: 3 },
            { value: (0, Translation_1.getKoName)('control', 'preventDetective'), span: 3, style: DesignReportColumn_1.blueStyle },
            { key: 'content.control.preventDetective', span: 3 },
            { value: (0, Translation_1.getKoName)('control', 'period'), span: 3, style: DesignReportColumn_1.blueStyle },
            { key: 'content.control.period', span: 3 }
        ],
        [
            { value: (0, Translation_1.getKoName)('risk', 'inherentRiskLevel'), span: 3, style: DesignReportColumn_1.blueStyle },
            { key: 'content.risk.inherentRiskLevel', span: 3 },
            { value: (0, Translation_1.getKoName)('control', 'residualRiskLevel'), span: 3, style: DesignReportColumn_1.blueStyle },
            { key: 'content.control.residualRiskLevel', span: 3 },
            { value: (0, Translation_1.getKoName)('control', 'controlRiskLevel'), span: 3, style: DesignReportColumn_1.blueStyle },
            { key: 'content.control.controlRiskLevel', span: 3 }
        ]
    ];
}
function getTOCColumns(isEditing) {
    return [
        [{ value: '통제평가절차', span: 24, style: DesignReportColumn_1.greyTitleStyle }],
        [
            {
                value: (0, Translation_1.getKoName)('control', 'TOC_TestMethod_InquiryInspection'),
                span: 4,
                style: DesignReportColumn_1.blueStyle
            },
            { key: 'content.control.TOC_TestMethod_InquiryInspection', span: 4 },
            { value: (0, Translation_1.getKoName)('control', 'TOC_TestMethod_Observation'), span: 4, style: DesignReportColumn_1.blueStyle },
            { key: 'content.control.TOC_TestMethod_Observation', span: 4 },
            { value: (0, Translation_1.getKoName)('control', 'TOC_TestMethod_Reperformance'), span: 4, style: DesignReportColumn_1.blueStyle },
            { key: 'content.control.TOC_TestMethod_Reperformance', span: 4 }
        ],
        [
            { value: (0, Translation_1.getKoName)('control', 'TOC_Procedure'), span: 4, style: DesignReportColumn_1.blueStyle },
            { key: 'content.control.TOC_Procedure', span: 12 },
            { value: (0, Translation_1.getKoName)('control', 'TOC_Evidence'), span: 4, style: DesignReportColumn_1.blueStyle },
            { key: 'content.control.TOC_Evidence', span: 4 }
        ],
        [
            { value: '설계일자 (Baseline) Reference', span: 4, style: DesignReportColumn_1.greyStyle },
            isEditing
                ? { key: 'baselineReference', span: 4, editable: true, type: 'DatePicker' }
                : { key: 'content.data.baselineReference', span: 4 },
            { value: (0, Translation_1.getKoName)('control', 'MRC_Number'), span: 4, style: DesignReportColumn_1.greyStyle },
            { key: 'content.control.MRC_Number', span: 4 },
            { value: (0, Translation_1.getKoName)('control', 'IPE_Number'), span: 4, style: DesignReportColumn_1.greyStyle },
            { key: 'content.control.IPE_Number', span: 4 }
        ]
    ];
}
var LegacyControl = /** @class */ (function (_super) {
    __extends(LegacyControl, _super);
    function LegacyControl() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.policy = '';
        _this.ITDependencySystem = '';
        _this.MRC_YN = AbstractControl_1.YesNo.no;
        _this.MRC_Number = '';
        _this.MRC_IPE_Name = '';
        _this.IPE_YN = AbstractControl_1.YesNo.no;
        _this.IPE_Number = '';
        _this.IPE_Name = '';
        _this.teamLeader = '';
        _this.teamMember = '';
        _this.goal_Trust = AbstractControl_1.YesNo.no;
        _this.goal_Override = AbstractControl_1.YesNo.no;
        _this.goal_Operation = AbstractControl_1.YesNo.no;
        _this.goal_Law = AbstractControl_1.YesNo.no;
        _this.goal_Asset = AbstractControl_1.YesNo.no;
        _this.accountCode = '';
        _this.accountName = '';
        _this.reportFootnotes = '';
        _this.assertion_EO = AbstractControl_1.YesNo.no;
        _this.assertion_C = AbstractControl_1.YesNo.no;
        _this.assertion_RO = AbstractControl_1.YesNo.no;
        _this.assertion_PD = AbstractControl_1.YesNo.no;
        _this.assertion_Occur = AbstractControl_1.YesNo.no;
        _this.assertion_Assessment = AbstractControl_1.YesNo.no;
        _this.assertion_Measurement = AbstractControl_1.YesNo.no;
        _this.autoManual = AbstractControl_1.AutoManual.auto;
        _this.TOC_Procedure = '';
        _this.TOC_Evidence = '';
        _this.TOC_Population = '';
        _this.TOC_PopulationCount = '';
        _this.TOC_TestProperties = '';
        _this.TOC_Exception = '';
        _this.TOC_TestMethod_InquiryInspection = AbstractControl_1.YesNo.no;
        _this.TOC_TestMethod_Observation = AbstractControl_1.YesNo.no;
        _this.TOC_TestMethod_Reperformance = AbstractControl_1.YesNo.no;
        return _this;
    }
    LegacyControl.getKeysForExporting = function () {
        return _super.getKeysForExporting.call(this, CONTROL_TYPES);
    };
    LegacyControl.from = function (data) {
        // TODO(sangmuk): Need to check proper variable.
        var control = new LegacyControl();
        Object.assign(control, data);
        return control;
    };
    LegacyControl.prepareEditingControls = function (control) {
        if (!(control instanceof LegacyControl)) {
            throw new Error("Invalid control class ".concat(control));
        }
        return _super.prepareEditingControlsInner.call(this, CONTROL_TYPES, control);
    };
    LegacyControl.getControlEditItems = function () {
        return _super.getControlEditItems.call(this, CONTROL_TYPES);
    };
    LegacyControl.convertFormToControl = function (formValues, selectedStaff) {
        var control = new LegacyControl();
        control.department = (selectedStaff === null || selectedStaff === void 0 ? void 0 : selectedStaff.departmentName) || '';
        return _super.convertFormToControlInner.call(this, CONTROL_TYPES, formValues, control);
    };
    LegacyControl.prototype.updateForOperationTemplate = function (newControl) {
        _super.prototype.updateForOperationTemplate.call(this, newControl);
        if (!(newControl instanceof LegacyControl)) {
            throw new Error('Different control types.');
        }
        this.TOC_Population = newControl.TOC_Population; // OE
        this.TOC_TestProperties = newControl.TOC_TestProperties; // OE
        this.TOC_TestMethod_InquiryInspection = newControl.TOC_TestMethod_InquiryInspection; // DE
        this.TOC_TestMethod_Observation = newControl.TOC_TestMethod_Observation; // DE
        this.TOC_TestMethod_Reperformance = newControl.TOC_TestMethod_Reperformance; // DE
        this.autoManual = newControl.autoManual; // OE, DE
        this.preventDetective = newControl.preventDetective; // DE
    };
    LegacyControl.prototype.getControlViewItems = function (staffs) {
        return _super.prototype.getControlViewItemsInner.call(this, CONTROL_TYPES, staffs);
    };
    LegacyControl.getDesignDefect = function () {
        var _a = _super.getDesignDefectInner.call(this, CONTROL_TYPES), infoData = _a.infoData, methodData = _a.methodData;
        infoData.push({ value: '관련 위험' });
        infoData.push({ type: 'risk', key: 'name' });
        infoData.push({ type: 'risk', key: 'RoMM' });
        infoData.push({ type: 'risk', key: 'inherentRiskLevel', radio: AbstractRisk_1.RiskLevel });
        return {
            infoData: infoData,
            methodData: methodData
        };
    };
    LegacyControl.getDesignDefectSummary = function () {
        var summaries = _super.getDesignDefectSummaryInner.call(this, CONTROL_TYPES);
        if (!('관련 위험' in summaries)) {
            throw new Error('No risk in defect summary.');
        }
        summaries['관련 위험'] = [
            { key: 'risk', subKey: 'name' },
            { key: 'risk', subKey: 'RoMM' },
            { key: 'risk', subKey: 'inherentRiskLevel' }
        ];
        return summaries;
    };
    LegacyControl.getDesignColumns = function (staffs, isEditing) {
        return _super.getDesignColumnsInner.call(this, staffs, isEditing, false, CONSIDERATIONS, getDesignControlTypes(), getTOCColumns(isEditing));
    };
    LegacyControl.getEditableDesignColumns = function () {
        return _super.getEditableDesignColumnsInner.call(this, CONSIDERATIONS, getTOCColumns(true));
    };
    return LegacyControl;
}(AbstractControl_1.default));
exports.default = LegacyControl;
//# sourceMappingURL=LegacyControl.js.map